<template>
  <v-row id="pagination" class="my-0" align-self="end" justify="center">
    <v-col v-show="items.length > 0" cols="3" sm="2" align-self="end">
      <v-select
        :items="[4, 8, 12, 16, 20, 24]"
        :label="$vuetify.lang.t('$vuetify.dataTable.itemsPerPageText')"
        v-model="perPage"
      ></v-select>
    </v-col>
    <v-col cols="9" sm="4" class="pt-5" v-show="items.length > 0">
      <v-pagination
        :length="total"
        total-visible="7"
        v-model="page"
      ></v-pagination>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    items: {
      required: true,
      type: Array
    },
    perPage: {
      required: true,
      type: Number
    },
    total: {
      required: true,
      type: Number
    },
    page: {
      required: true,
      type: Number
    }
  }
}
</script>
